import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './ContactInformation.module.scss'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import BackNextButtons from 'shared/components/BackNextButtons.jsx'
import EmailAddress from './EmailAddress'
import BackAnchor from '../../../../shared/components/BackAnchor'

const ContactInformationView = ({ t, i18n, setIsError }) => {
  const history = useHistory()

  const [emailAddressValid, setEmailAddressValid] = useState('')
  const [confirmEmailAddressValid, setConfirmEmailAddressValid] = useState('')

  const [emailAddressError, setEmailAddressError] = useState('contact_info.email_address_error')
  const [confirmEmailAddressError, setConfirmEmailAddressError] = useState('contact_info.confirm_email_address_error')

  const emailAddress = useSelector((state) => state.app.emailAddress)
  const confirmEmailAddress = useSelector((state) => state.app.confirmEmailAddress)

  const cases = useSelector((state) => state.app.cases)

  const backNextProps = {
    prevText: t('contact_info.back'),
    prevURL: `/${i18n.language}${t('routes.listed_cases')}`,
    nextText: t('contact_info.next'),
  }

  useEffect(() => {
    try {
      if (cases.length === 0) {
        history.push(`/${i18n.language}${t('routes.case_info')}`)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [])

  const onNext = () => {
    try {
      if (validateFields()) {
        history.push(`/${i18n.language}${t('routes.review_confirmation')}`)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateFields = () => {
    try {
      let isValid = false
      if (emailAddress) {
        if (validateEmailAddress(emailAddress)) {
          isValid = true
        } else {
          setEmailAddressError('contact_info.email_address_error_invalid')
        }
      } else {
        setEmailAddressError('contact_info.email_address_error')
      }
      setEmailAddressValid(isValid)
      return isValid
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateEmailAddress = (email) => {
    const regex = RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
    return regex.test(email)
  }

  const validateConfirmEmail = (confirmEmail) => {
    try {
      if (confirmEmail && confirmEmail.toUpperCase() === emailAddress.toUpperCase()) {
        setConfirmEmailAddressValid(true)
      } else {
        setConfirmEmailAddressValid(false)
        setConfirmEmailAddressError('contact_info.confirm_email_address_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  return (
    <div className="container">
      <BackAnchor />
      <div className="row">
        <div className="col-xs-12 col-lg-12">
          <h1>{t('contact_info.give_your')}</h1>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-12">
          <EmailAddress
            validateEmailAddress={validateEmailAddress}
            emailAddressError={emailAddressError}
            emailAddressValid={emailAddressValid}
            setIsError={setIsError}
          />
          {/* <ConfirmEmailAddress
              validateConfirmEmail={validateConfirmEmail}
              confirmEmailAddressError={confirmEmailAddressError}
              confirmEmailAddressValid={confirmEmailAddressValid}
              setIsError={setIsError}
            /> */}
        </div>
      </div>
      <div className={styles['back_next_margin']}>
        <BackNextButtons props={backNextProps} nextOnClick={onNext} displayBack={false} />
      </div>
    </div>
  )
}

export default withTranslation('common')(ContactInformationView)
